import {createAction, props} from "@ngrx/store";
import {CreateFiuCommand, FiuDto, FIUStatusEnum, UpdateFiuCommand} from "@esa/api";
import {EnumDetailDto} from "@esa/api/models/EnumDetailDto";

export const getFius = createAction(
  '[Fius] Get Fius',
  props<{ pageNumber: number, pageSize: number, fiuStatus: FIUStatusEnum }>()
)
export const getFiusSuccess = createAction(
  '[Fius] Get Fius Success',
  props<{ fius: FiuDto[], totalRecords: number }>()
)
export const getFiusError = createAction(
  '[Fius] Get Fius Error',
)

export const setSelectedFiu = createAction(
  '[Fius] Set Selected FIU',
  props<{ selectedFiu: FiuDto }>()
)

export const updateFiu = createAction(
  '[Fius] Update FIU',
  props<{ fiu : UpdateFiuCommand }>()
)

export const updateFiuSuccess = createAction(
  '[Fius] Update FIU Success',
)

export const updateFiuError = createAction(
  '[Fius] Update FIU Error',
)

export const archiveFiu = createAction(
  '[Fius] Archive FIU',
  props<{ fiu: UpdateFiuCommand, pageNumber: number, pageSize: number }>(),
)

export const archiveFiuSuccess = createAction(
  '[Fius] Archive FIU Success',
  props<{pageNumber: number, pageSize: number}>()
)

export const archiveFiuError = createAction(
  '[Fius] Archive FIU Error',
)

export const createFiu = createAction(
  '[Fius] Create FIU',
  props<{ fiu: CreateFiuCommand }>()
)

export const createFiuSuccess = createAction(
  '[Fius] Create FIU Success',
)

export const createFiuError = createAction(
  '[Fius] Create FIU Error',
)

export const getFiuStatuses = createAction(
  '[Fius] Get FIU Statuses',
)

export const getFiuStatusesSuccess = createAction(
  '[Fius] Get FIU Statuses Success',
  props<{ fiuStatuses : EnumDetailDto[] }>(),
)

export const getFiuStatusesError = createAction(
  '[Fius] Get FIU Statuses Error',
)

export const getFiuList = createAction(
  '[Fius] Get FIU List',
)

export const getFiuListSuccess = createAction(
  '[Fius] Get FIU List Success',
  props<{ fiuList : FiuDto[] }>(),
)

export const getFiuListError = createAction(
  '[Fius] Get FIU List Error',
)

export const activateFiu = createAction (
  '[Fius] Activate FIU',
  props<{ fiu: UpdateFiuCommand, pageNumber: number, pageSize: number }>(),
)

export const activateFiuSuccess = createAction(
  '[Fius] Activate FIU Success',
  props<{pageNumber: number, pageSize: number}>()
)

export const activateFiuError = createAction(
  '[Fius] Activate FIU Error',
)
